<template>
  <div>
    <template v-if="!isLoading && !plugins.length">
      <add-first-site />
    </template>

    <c-row v-show="isLoading">
      <c-col sm="12">
        <p class="lead">
          Getting plugins...
          <c-spinner color="success" size="sm" />
        </p>
      </c-col>
    </c-row>

    <template v-if="!isLoading && plugins.length">
      <c-row>
        <c-col sm="12">
          <c-tabs>
            <c-tab title="Sites" active>
              <template slot="title">
                <c-icon :content="freeSet.cilPuzzle" />
                Plugins
                <pill :value="plugins.length" width="40px" />
              </template>
              <plugin-list
                :plugins="plugins"
                :hide-header="true"
                :show-only-require-updates="true"
                :view-type-default="'grid'"
              />
            </c-tab>
          </c-tabs>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { buildEndpoint } from '@/libs/buildEndPoint';
import Plugins from '../components/dashboard/plugins';
import Pill from '../components/Pill';
import PluginList from '../components/plugin-list';
import AddFirstSite from '@/views/components/dashboard/AddFirstSite';

export default {
  name: 'Plugins',

  components: {
    Plugins,
    Pill,
    PluginList,
    AddFirstSite,
  },

  data() {
    return {
      isLoading: true,
      freeSet,
      plugins: [],
      sitesViewType: 'grid',
      numberOfPluginsRequiringUpdates: 0,
      numberOfPlugins: 0,
      error: null,
    };
  },

  computed: {},

  created() {
    this.get();
  },

  methods: {
    get() {
      this.$http
        .get(buildEndpoint('plugin/organisation'))
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.plugins = response.data.data;
          } else {
            this.error = 'Error getting plugins';
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
ol {
  margin-left: 30px;
}

.plugin-list {
  thead {
    tr {
      th {
        &:first-child {
          width: 40%;
        }
      }
    }
  }
}
</style>
